import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Grid from '@material-ui/core/Grid'

// EXTRA COMPONENTS
import SkewBg from './SkewBg'
import SimpleParagraphWButtonGrey from '../../Utilities/SimpleParagraphWButtonGrey'

// import CardNFC from './CardNFC'
// import CardNFC from './CardNFC'

// IMAGES
import Team from '../../../assets/Team/Team.png'

export default class MeetTheTeam extends React.Component{
    render(){
    return(
        <section id="MeetTheTeam" className={css(styles.MainContainer)}>
            <SkewBg />
            <div className="container">
                <section className={css(styles.SecondaryContainer)}>
                    <Grid spacing={32} container alignItems="center">
                        <Grid item md={4} xs={12} className={css(styles.container)}>
                            <SimpleParagraphWButtonGrey title="The Lemon Team" subtitle="About Us" 
                            text="We are a group of visionaries, passionate about our work. In our team we have different areas: Artists, developers..." />
                        </Grid>
                        <Grid item md={8}>
                            <img className={css(styles.TeamImg)} src={Team} alt=""/>
                        </Grid>
                    </Grid>
                </section>
            </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    MainContainer: {
        position: 'relative',
        marginTop: -100
    },
    SecondaryContainer: {
        paddingTop: '35%',
    	color: '#595959',
        lineHeight: '1.8em',
        '@media (max-width: 768px)':{
            paddingTop: '100%'
        }
    },
    introButton: {
        color: 'white',
        width: 180,
        background: 'linear-gradient(-161deg, #FF6B4D, #D85944)',
        borderRadius: 200,
        lineHeight: 0,
        paddingRight: '10px',
        marginTop: '5%',
        boxShadow: '0 18px 35px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)',
        transition: 'all ease-in-out .2s',
        ':hover':{
            transform: 'translate(0, -2px)',
            boxShadow: '0 20px 40px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#7047D6',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    },
    TeamImg: {
        pointerEvents: 'none',
        maxHeight: 350,
        transition: 'all ease-in-out .2s',
        cursor: 'pointer',
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))',
        maxWidth: '100%',
         ':hover':{
            transform: 'translate(0, -2px)',
            filter: 'drop-shadow(0 12px 15px rgba(0,0,0,.14)) drop-shadow(0px 4px 8px rgba(0,21,64,.14))',
        }

    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/MeetTheTeam/MeetTheTeam.js